import type { DeliveryLimits } from "@store/slices/magentoApiSlice/endpoints/getOrderDeliveryLimits.endpoint";

import type { MagentoApiGetOrderDeliveryLimitsQueryResponse } from "@jti/magento-api-v2";

type RawDeliveryLimits = MagentoApiGetOrderDeliveryLimitsQueryResponse["getOrderDeliveryLimits"];
type RawDeliveryLimitItem = NonNullable<NonNullable<RawDeliveryLimits>["limits"]>[number];
type DeliveryLimitItem = NonNullable<DeliveryLimits>["limits"][number];

const containsAllRequiredProps = (
  limit: RawDeliveryLimitItem | null | undefined
): limit is NonNullable<RawDeliveryLimitItem> & DeliveryLimitItem =>
  Boolean(limit?.id && limit.country_id && limit.name);

export const normalizeDeliveryLimitsResponse = (deliveryLimits: RawDeliveryLimits | undefined): DeliveryLimits => {
  if (!deliveryLimits?.mode) {
    return undefined;
  }

  return {
    mode: deliveryLimits.mode,
    limits: (deliveryLimits.limits ?? []).filter(containsAllRequiredProps),
  };
};
